// Navigation structure (mega-menu)
import {
  Brain,
  Gauge,
  Search,
  MapPin,
  Megaphone,
  Users,
  FileText,
  Mail,
  Zap,
  Monitor,
  TrendingUp,
  Play,
  Star,
  ShoppingBag,
  Home,
  Scissors,
  BookOpen,
  LayoutGrid,
  Briefcase,
  Handshake,
  Phone,
  Info,
  LineChart,
  PenLine,
  Palette,
  Workflow,
  Link as LinkIcon,
  Bot,
} from "lucide-react";

export const MEGA_NAV = [
  {
    label: "Services",
    key: "services",
    columns: [
      {
        title: "Core Services",
        items: [
          {
            label: "AI Automation",
            desc: "AI agents per industry · lead response · booking · support",
            icon: Bot,
            href: "/ai-automation",
          },
          {
            label: "AI Search Optimization (GEO/AEO)",
            desc: "Get found in ChatGPT, Gemini & AI Overviews",
            icon: Brain,
            href: "/ai-search-optimization",
          },
          {
            label: "Search Engine Optimization",
            desc: "Rank higher · grow organic traffic",
            icon: Search,
            href: "/seo",
          },
          {
            label: "Local SEO",
            desc: "Dominate 'near me' searches",
            icon: MapPin,
            href: "/local-seo",
          },
          {
            label: "Paid Advertising (PPC)",
            desc: "Google Ads · Meta Ads · ROI-focused",
            icon: Megaphone,
            href: "/paid-advertising",
          },
          {
            label: "Social Media Management",
            desc: "Content · scheduling · community growth",
            icon: Users,
            href: "/social-media",
          },
          {
            label: "Email & SMS Marketing",
            desc: "Automated flows · newsletters · revenue",
            icon: Mail,
            href: "/email-sms",
          },
        ],
      },
      {
        title: "Growth Services",
        items: [
          {
            label: "Conversion Rate Optimization",
            desc: "A/B testing · funnel optimisation · 2-5× lift",
            icon: LineChart,
            href: "/cro",
          },
          {
            label: "Content Marketing",
            desc: "SEO content · blogs · lead magnets · copy",
            icon: PenLine,
            href: "/content-marketing",
          },
          {
            label: "Website Design & Development",
            desc: "Conversion-focused sites · Webflow · Shopify",
            icon: Palette,
            href: "/web-design",
          },
          {
            label: "Marketing Automation",
            desc: "HubSpot · Klaviyo · ActiveCampaign · GHL",
            icon: Workflow,
            href: "/marketing-automation",
          },
          {
            label: "Link Building & Digital PR",
            desc: "High-DR backlinks · HARO · digital PR",
            icon: LinkIcon,
            href: "/link-building",
          },
        ],
      },
      {
        title: "Industry Solutions",
        items: [
          {
            label: "Shopify & Ecommerce",
            desc: "Scale store revenue · Shopping ads · Klaviyo",
            icon: ShoppingBag,
            href: "/shopify-ecommerce",
          },
          {
            label: "Real Estate Marketing",
            desc: "Qualified leads · Local SEO · Automation",
            icon: Home,
            href: "/real-estate-marketing",
          },
          {
            label: "Salon & Spa Marketing",
            desc: "Fill bookings · Instagram · Review automation",
            icon: Scissors,
            href: "/salon-spa-marketing",
          },
        ],
      },
    ],
  },
  {
    label: "Resources",
    key: "resources",
    columns: [
      {
        title: "Free Tools",
        items: [
          {
            label: "Free SEO Audit Tool",
            desc: "Get a 12-page audit of your website in 24h",
            icon: Gauge,
            href: "/seo-audit",
          },
          {
            label: "Free Marketing Audit",
            desc: "Full-funnel marketing review · senior strategist",
            icon: Search,
            href: "/free-aso-audit",
          },
        ],
      },
      {
        title: "Learn",
        items: [
          {
            label: "Blog",
            desc: "Digital marketing playbooks & growth notes",
            icon: FileText,
            href: "/blog",
          },
          {
            label: "Resources",
            desc: "Templates, guides, checklists",
            icon: BookOpen,
            href: "/resources",
          },
          {
            label: "Case Studies",
            desc: "Real client results, fully audited",
            icon: LayoutGrid,
            href: "/case-studies",
          },
        ],
      },
    ],
  },
  {
    label: "Company",
    key: "company",
    columns: [
      {
        title: "About",
        items: [
          {
            label: "About Lumotis",
            desc: "Who we are and how we work",
            icon: Info,
            href: "/about",
          },
          {
            label: "Careers",
            desc: "Join the growth team",
            icon: Briefcase,
            href: "/careers",
          },
          {
            label: "Partners",
            desc: "Agencies, affiliates & tech partners",
            icon: Handshake,
            href: "/partners",
          },
          {
            label: "Contact",
            desc: "Book a call or message us",
            icon: Phone,
            href: "/contact",
          },
        ],
      },
    ],
  },
];
